/// <amd-module name="Work/Views/MyWork/Constants/ContributionRoutes" />
export const WorkItemRoute = "ms.vss-work-web.work-items-form-route-with-id";
export const ProjectRoute = "ms.vss-tfs-web.project-overview-route";
